import React, { useEffect } from "react";
import { trackPageView, getSessionId, getUserId } from "../utils/pageTracking";
import ContactForm from "../components/ContactUs";

const ContactUsPage: React.FC = () => {
    useEffect(() => {
        // Track page view
        trackPageView('ContactUs', getSessionId(), getUserId());
        
        // Scroll to top when page loads
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-[#fafaf3] pt-16">
            {/* Hero Section */}
            <section className="w-full bg-[#c3d3ab] text-white py-12">
                <div className="container mx-auto px-6 text-center">
                    <h1 className="font-mono text-orange-600 text-4xl md:text-5xl lg:text-6xl mb-6">
                        Contact Us
                    </h1>
                    <p className="text-xl md:text-2xl max-w-3xl mx-auto text-black">
                        Have questions about our composting services? We'd love to hear from you!
                    </p>
                </div>
            </section>

            {/* Contact Form Section */}
            <section className="py-12">
                <ContactForm
                    headingText="Get in Touch"
                    subText="Send us a message and we'll get back to you as soon as possible."
                    headingClassName="text-[#b05e2c]"
                    showPhone={true}
                    showSubject={true}
                    submitButtonText="Send Message"
                    socialIcons={true}
                    twoColumn={true}
                />
            </section>

            {/* Additional Information Section */}
            <section className="bg-[#c3d3ab] py-12">
                <div className="container mx-auto px-6">
                    <div className="max-w-4xl mx-auto grid md:grid-cols-3 gap-8 text-center">
                        <div className="bg-white/90 rounded-lg p-6">
                            <div className="text-4xl mb-3">📧</div>
                            <h3 className="text-xl font-semibold text-[#b05e2c] mb-2">Email Us</h3>
                            <p className="text-gray-700">
                                Questions about our services? Drop us an email and we'll respond quickly.
                            </p>
                        </div>
                        <div className="bg-white/90 rounded-lg p-6">
                            <div className="text-4xl mb-3">🌱</div>
                            <h3 className="text-xl font-semibold text-[#b05e2c] mb-2">Composting Questions</h3>
                            <p className="text-gray-700">
                                New to composting? We're here to help you get started with sustainable waste management.
                            </p>
                        </div>
                        <div className="bg-white/90 rounded-lg p-6">
                            <div className="text-4xl mb-3">📱</div>
                            <h3 className="text-xl font-semibold text-[#b05e2c] mb-2">Follow Us</h3>
                            <p className="text-gray-700">
                                Stay updated with composting tips and news by following us on social media.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ContactUsPage;
